import Swiper, { Navigation, Pagination, Autoplay, Thumbs, Controller, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, Controller]);

function contentSlider() {
  const contentSliderElement = document.getElementById('content-slider');
  const contentSliderInidicator = document.getElementById(
    'content-slider-indicator'
  );

  // eslint-disable-next-line no-new
  new Swiper(contentSliderElement, {
    loop: false,
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    },
    on: {
      beforeTransitionStart: function() {
        contentSliderInidicator.classList.add('hidden');
      }
    }
  });
}

function relatedProductsSlider() {
  const contentSliderElement = document.getElementById(
    'related-products-slider'
  );
  const contentSliderInidicator = document.getElementById(
    'related-products-slider-indicator'
  );
  const contentSliderNavigation = document.getElementById(
    'related-products-slider-navigation'
  );

  // eslint-disable-next-line no-new
  new Swiper(contentSliderElement, {
    modules: [Navigation],
    loop: false,
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    navigation: {
      nextEl: '#related-products-slider-next',
      prevEl: '#related-products-slider-prev'
    },
    on: {
      init: function() {
        if (contentSliderNavigation != null && this.slides.length <= 4) {
          contentSliderNavigation.classList.add('hide-nav-xl');
        }
      },
      beforeTransitionStart: function() {
        contentSliderInidicator.classList.add('hidden');
      }
    }
  });
}

function logoSlider() {
  const logoSliderElement = document.getElementById('logo-slider');

  // eslint-disable-next-line no-new
  new Swiper(logoSliderElement, {
    loop: true,
    autoplay: true,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 50
      },
      450: {
        slidesPerView: 2,
        spaceBetween: 60
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 60
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 110
      }
    }
  });
}

function quoteSlider() {
  const logoSliderElement = document.getElementById('quote-slider');

  if (logoSliderElement != null) {
    // eslint-disable-next-line no-new
    new Swiper(logoSliderElement, {
      modules: [Pagination],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 30
        }
      }
    });
  }
}

function productOutlineSlider() {
  const productOutlineSliderElement = document.getElementById(
    'product-outline-slider'
  );
  const productOutlineThumbsElement = document.getElementById(
    'product-outline-thumbs'
  );

  if (productOutlineSliderElement != null) {
    // eslint-disable-next-line no-new
    const thumbsSwiper = new Swiper(productOutlineThumbsElement, {
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      spaceBetween: 10,
      direction: 'vertical'
    });

    // eslint-disable-next-line no-new
    new Swiper(productOutlineSliderElement, {
      modules: [Thumbs],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: {
        swiper: thumbsSwiper
      }
    });
  }
}




function heroSlider() {
    
  const heroTextSwiper = new Swiper('.hero-text-slider', {
    modules: [EffectFade],
    // effect: "slide",
    effect: 'fade',    
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    allowTouchMove: false,
  });

  const $Speed = 1000;

  const heroImageSwiper = new Swiper('.hero-image-slider', {
    modules: [EffectFade],      
    speed: $Speed,
    slidesPerView: 1,
    loop: true, 
    grabCursor: true,
    watchSlidesProgress: true,
    // effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-hero-button-next',
      prevEl: '.swiper-hero-button-prev',
    }
  });

  heroImageSwiper.controller.control = heroTextSwiper;

}



export {
  contentSlider,
  relatedProductsSlider,
  logoSlider,
  quoteSlider,
  productOutlineSlider,
  heroSlider
};
